import { createFileRoute } from "@tanstack/react-router"

import { DiligencePanel } from "@/pages/DiligencePanel"

export const Route = createFileRoute("/operations/diligence")({
  component: DiligencePanel,
})
